<template>
  <div></div>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
};
</script>
